import {writable} from 'svelte/store';

export const mainDialogOpen = writable(false);

export const openMainDialog = () => mainDialogOpen.set(true);
export const closeMainDialog = () => mainDialogOpen.set(false);
export const toggleMainDialog = () => mainDialogOpen.update(v => !v);